import React from "react";

export default function HeroDashboardSVG({theme,accent}){
  const dk=theme==="dark";
  const bg=dk?"#0d0d14":"#f5f4f2";const card=dk?"#161620":"#ffffff";const bd=dk?"#252530":"#e8e5e0";
  const tx=dk?"#f0efe8":"#1a1714";const mt=dk?"#7a7a88":"#6b6660";
  const gr="#2D7D52";const rd="#D94F3D";const bl="#2B5EA7";const am="#D97706";
  const W=700,P=14;
  return(
    <svg viewBox={`0 0 ${W} 420`} style={{width:"100%",display:"block",borderRadius:12}} xmlns="http://www.w3.org/2000/svg">
      <rect width={W} height="420" rx="12" fill={bg}/>
      {/* Stat row — 4 equal */}
      {[{l:"Staff On Duty",v:"6 / 8",c:gr},{l:"Open Tasks",v:"12",c:am},{l:"Approvals",v:"3",c:rd},{l:"Spend",v:"SAR 38K",c:bl}].map((s,i)=>{
        const cw=(W-P*5)/4;return(<g key={i}>
          <rect x={P+i*(cw+P)} y={P} width={cw} height={52} rx="8" fill={card} stroke={bd} strokeWidth="1"/>
          <text x={P+i*(cw+P)+10} y={32} fontSize="8" fill={mt} fontFamily="Inter,sans-serif">{s.l}</text>
          <text x={P+i*(cw+P)+10} y={52} fontSize="15" fill={tx} fontFamily="Inter,sans-serif" fontWeight="700">{s.v}</text>
          <circle cx={P+i*(cw+P)+cw-10} cy={26} r="3.5" fill={s.c} opacity=".5"/>
        </g>);
      })}
      {/* Row 2 — Tasks + Staff — 2 equal columns */}
      {(() => {const cw2=(W-P*3)/2;const y2=78;const h2=140;return [0,1].map(col=>{
        const x=P+col*(cw2+P);return(<g key={col}>
          <rect x={x} y={y2} width={cw2} height={h2} rx="10" fill={card} stroke={bd} strokeWidth="1"/>
          {col===0?<>
            <text x={x+12} y={y2+20} fontSize="10" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">Today's Tasks</text>
            {[{t:"Pool cleaning — Farm",s:"In Progress",sc:am},{t:"AC filter — Villa",s:"Scheduled",sc:bl},{t:"Irrigation check",s:"Done",sc:gr},{t:"Gate sensor repair",s:"Overdue",sc:rd}].map((tk,i)=>(
              <g key={i}>
                <circle cx={x+16} cy={y2+42+i*26} r="3" fill={tk.sc} opacity=".7"/>
                <text x={x+24} y={y2+45+i*26} fontSize="8.5" fill={tx} fontFamily="Inter,sans-serif">{tk.t}</text>
                <rect x={x+cw2-72} y={y2+34+i*26} width={58} height="15" rx="4" fill={tk.sc} opacity=".12"/>
                <text x={x+cw2-43} y={y2+44+i*26} fontSize="7" fill={tk.sc} fontWeight="600" fontFamily="Inter,sans-serif" textAnchor="middle">{tk.s}</text>
              </g>))}
          </>:<>
            <text x={x+12} y={y2+20} fontSize="10" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">Staff & Leave</text>
            {[{n:"Ahmad — Driver",s:"On Duty",sc:gr},{n:"Sara — Manager",s:"On Duty",sc:gr},{n:"Omar — Gardener",s:"Leave Req.",sc:am},{n:"Fatima — Cook",s:"On Duty",sc:gr}].map((st,i)=>(
              <g key={i}>
                <circle cx={x+16} cy={y2+42+i*26} r="8" fill={[accent,bl,am,gr][i]} opacity=".15"/>
                <text x={x+16} y={y2+45+i*26} fontSize="7" fill={[accent,bl,am,gr][i]} textAnchor="middle" fontWeight="700" fontFamily="Inter,sans-serif">{st.n[0]}</text>
                <text x={x+28} y={y2+45+i*26} fontSize="8.5" fill={tx} fontFamily="Inter,sans-serif">{st.n}</text>
                <rect x={x+cw2-72} y={y2+34+i*26} width={58} height="15" rx="4" fill={st.sc} opacity=".12"/>
                <text x={x+cw2-43} y={y2+44+i*26} fontSize="7" fill={st.sc} fontWeight="600" fontFamily="Inter,sans-serif" textAnchor="middle">{st.s}</text>
              </g>))}
          </>}
        </g>);
      });})()}
      {/* Row 3 — Grocery + Meals + Facility — 3 equal columns */}
      {(() => {const cw3=(W-P*4)/3;const y3=230;const h3=176;return [0,1,2].map(col=>{
        const x=P+col*(cw3+P);return(<g key={col}>
          <rect x={x} y={y3} width={cw3} height={h3} rx="10" fill={card} stroke={bd} strokeWidth="1"/>
          {col===0?<>
            <text x={x+10} y={y3+18} fontSize="9.5" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">Grocery List</text>
            <text x={x+10} y={y3+30} fontSize="7" fill={mt} fontFamily="Inter,sans-serif">Requested by Cook</text>
            {["Chicken breast x4","Rice 5kg","Tomatoes 2kg","Olive oil","Fresh herbs"].map((g2,i)=>(
              <g key={i}>
                <rect x={x+10} y={y3+38+i*18} width="7" height="7" rx="1.5" fill={i<3?gr:bd} opacity={i<3?.3:.15}/>
                <text x={x+22} y={y3+45+i*18} fontSize="8" fill={i<3?mt:tx} fontFamily="Inter,sans-serif" opacity={i<3?.5:1}>{g2}</text>
              </g>))}
            <rect x={x+10} y={y3+h3-24} width={56} height="15" rx="4" fill={accent} opacity=".15"/>
            <text x={x+38} y={y3+h3-14} fontSize="7" fill={accent} fontWeight="600" fontFamily="Inter,sans-serif" textAnchor="middle">Send to Driver</text>
          </>:col===1?<>
            <text x={x+10} y={y3+18} fontSize="9.5" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">Meal Plan</text>
            {[{m:"Breakfast",d:"Eggs, toast, juice",t:"7 AM"},{m:"Lunch",d:"Chicken, rice, salad",t:"1 PM"},{m:"Dinner",d:"Lamb kabsa",t:"8 PM"}].map((ml,i)=>(
              <g key={i}>
                <rect x={x+8} y={y3+28+i*46} width={cw3-16} height={38} rx="6" fill={dk?"#1a1a24":"#f9f8f6"} stroke={bd} strokeWidth=".5"/>
                <text x={x+16} y={y3+44+i*46} fontSize="8.5" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">{ml.m}</text>
                <text x={x+16} y={y3+55+i*46} fontSize="7" fill={mt} fontFamily="Inter,sans-serif">{ml.d}</text>
                <text x={x+cw3-14} y={y3+44+i*46} fontSize="7" fill={mt} textAnchor="end" fontFamily="Inter,sans-serif">{ml.t}</text>
              </g>))}
          </>:<>
            <text x={x+10} y={y3+18} fontSize="9.5" fill={tx} fontWeight="600" fontFamily="Inter,sans-serif">Facility — Farm</text>
            {[{t:"Irrigation",s:"OK",sc:gr},{t:"Generator",s:"Service Due",sc:am},{t:"Cameras",s:"OK",sc:gr},{t:"Water tank",s:"62%",sc:bl},{t:"Solar panels",s:"Active",sc:gr}].map((f,i)=>(
              <g key={i}>
                <text x={x+10} y={y3+38+i*24} fontSize="8" fill={tx} fontFamily="Inter,sans-serif">{f.t}</text>
                <rect x={x+cw3-62} y={y3+28+i*24} width={50} height="14" rx="3" fill={f.sc} opacity=".12"/>
                <text x={x+cw3-37} y={y3+38+i*24} fontSize="7" fill={f.sc} fontWeight="600" fontFamily="Inter,sans-serif" textAnchor="middle">{f.s}</text>
              </g>))}
          </>}
        </g>);
      });})()}
    </svg>
  );
}
